import { render, staticRenderFns } from "./Builds.vue?vue&type=template&id=39761c9e"
import script from "./Builds.vue?vue&type=script&lang=js"
export * from "./Builds.vue?vue&type=script&lang=js"
import style0 from "./Builds.vue?vue&type=style&index=0&id=39761c9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports